import { render } from "./FloristMeetingSendMail.vue?vue&type=template&id=200a8a3c&scoped=true"
import script from "./FloristMeetingSendMail.vue?vue&type=script&lang=js"
export * from "./FloristMeetingSendMail.vue?vue&type=script&lang=js"

import "./FloristMeetingSendMail.vue?vue&type=style&index=0&id=200a8a3c&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/environment/links-frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-200a8a3c"]])

export default __exports__